module.exports = __webpack_public_path__ + "img/t_third_prize.41766408.png";